import Feedback from '../container/Feedback';
import {
  initTransCustomerFeedbackAggreatorServiceClient,
  initCustomClient,
} from '../clients/TransCustomerFeedbackAggreatorServiceClient';

/** @typedef {import("@amzn/ihm-js-coral-client").CoralClientConfigFactory} CoralClientConfigFactory */
/** @typedef {import("@amzn/ihm-js-coral-client").CoralInterceptor} CoralInterceptor */

/**
 * Get the Feedback entry point after initializing the js client
 *
 * @param {{
 *    env: string,
 *    requestOptionsInterceptor: CoralInterceptor,
 *    client: any
 * }} clientOptions - JS client options for initializing the js client
 */
const feedback = (clientOptions) => {
  // Initialize the service client
  const { env, requestOptionsInterceptor, client } = clientOptions;
  if (client) {
    initCustomClient(client);
  } else {
    initTransCustomerFeedbackAggreatorServiceClient(
      env,
      requestOptionsInterceptor
    );
  }

  return Feedback;
};

export default feedback;
